import { useCallback } from "react";
import { toast } from "sonner";

export function useErrorToast() {
  return useCallback((message?: string) => {
    toast("Error", {
      description: message || "Erro desconhecido",
    });
  }, []);
}
